import { SvgIcon } from '@mui/material'

export function ArrowLeftIcon(props) {
  return (
    <SvgIcon {...props} fill={'none'}>
      <path
        d="M19 12H5M5 12L12 19M5 12L12 5"
        fill={'none'}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
